import images from 'config/local/images.js';
import React from 'react';
import SocialMediaLink from './SocialMediaLink';
import SocialShareModal from './Modals/SocialShareModal';

export default class SocialMediaLinks extends React.Component {
	/**
	 * @param {object} props
	 * @param {string} props.url
	 * @param {string} [props.className]
	 * @param {string} [props.title]
	 * @param {string} [props.imageUrl]
	 * @param {boolean} [props.blogPreview]
	 */
	constructor(props) {
		super(props);
		this.state = {
			instagramModalOpen: false,
		};
		this.handleInstagramClick = this.handleInstagramClick.bind(this);
		this.closeInstagramModal = this.closeInstagramModal.bind(this);
	}

	/**
	 * @param {string} text
	 */
	// eslint-disable-next-line class-methods-use-this
	unsecuredCopyToClipboard(text) {
		const textArea = document.createElement('textarea');
		textArea.value = text;
		textArea.style.top = '0';
		textArea.style.left = '0';
		textArea.style.position = 'fixed';
		document.body.appendChild(textArea);
		textArea.focus();
		textArea.select();
		document.execCommand('copy');
		document.body.removeChild(textArea);
	}

	/**
	 * @param {React.MouseEvent} event
	 */
	handleInstagramClick(event) {
		event.preventDefault();
		const url = this.props.url;
		if (url) {
			if (window.navigator && window.navigator.clipboard) {
				window.navigator.clipboard.writeText(url).catch(() => {
					this.unsecuredCopyToClipboard(url);
				});
			} else {
				this.unsecuredCopyToClipboard(url);
			}
		}
		this.setState({ instagramModalOpen: true });
	}

	closeInstagramModal() {
		this.setState({ instagramModalOpen: false });
	}

	render() {
		const uriEncodedUrl = encodeURIComponent(this.props.url);

		let socialMediaTypes = [
			{
				src: images.social.facebook,
				type: 'facebook',
				url: `http://www.facebook.com/sharer/sharer.php?u=${uriEncodedUrl}&display=popup`,
			},
			{
				src: images.social.twitterX,
				type: 'twitterX',
				url: `https://x.com/intent/post?text=${this.props.title}&url=${uriEncodedUrl}`,
			},
			{
				src: images.social.instagram,
				type: 'instagram',
				url: '#', // Handled by onClick
			},
			{
				src: images.social.linkedin,
				type: 'linkedin',
				url: `https://www.linkedin.com/sharing/share-offsite/?url=${uriEncodedUrl}`,
			},
			{
				src: images.social.pinterest,
				type: 'pinterest',
				url: `https://www.pinterest.com/pin/create/link/?url=${uriEncodedUrl}&media=${this.props.imageUrl}`,
			},
		];

		if (this.props.blogPreview) {
			socialMediaTypes = socialMediaTypes.slice(0, 3);
		}

		return (
			<React.Fragment>
				{socialMediaTypes.map((socialMedia) => (
					<SocialMediaLink
						className={this.props.className}
						key={socialMedia.type}
						onClick={
							socialMedia.type === 'instagram'
								? this.handleInstagramClick
								: undefined
						}
						src={socialMedia.src}
						type={socialMedia.type}
						url={socialMedia.url}
					/>
				))}
				<SocialShareModal
					authorImage={this.props.authorImage}
					authorName={this.props.authorName}
					date={this.props.date}
					handleClose={this.closeInstagramModal}
					heroImage={this.props.imageUrl}
					isOpen={this.state.instagramModalOpen}
					title={this.props.title || 'Blog Post'}
					url={this.props.url}
				/>
			</React.Fragment>
		);
	}
}
